// @flow

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import BoostTextExperiment from 'app/common/react/components/Business/BoostTextExperiment';
import DeprecatedPinRep from 'app/common/react/components/DeprecatedPinRep/DeprecatedPinRep';
import DisplayPinImage from 'app/common/react/components/DisplayPinImage/DisplayPinImage';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import PinStatsOnGrid from 'app/common/react/components/PinAnalytics/PinStatsOnGrid';
import type { Dispatch } from 'redux';
import type { SummaryPin } from 'app/packages/pinterest-flow-types/pin';
import { GRID_ITEM_WIDTH } from 'app/common/lib/react/gridUtils';
import { logQuickPromoteEvents } from 'app/common/lib/BusinessLoggingUtils';
import { showQuickPromoteModal } from 'app/common/redux/actions/quickPromote';
import { type PinWithAnalytics } from 'app/common/react/components/growth/smb/OverviewCreatorPromotablePinsGrid/OverviewCreatorPromotablePinsGrid';
import { Box, Button } from 'gestalt';

type Props = {|
  carouselPin?: SummaryPin,
  component: string,
  dispatch: Dispatch<any>,
  grid_index: number,
  isShort?: boolean,
  onPromote?: () => void,
  pin: ?PinWithAnalytics,
  show90DaysStats: boolean,
  view: string,
  viewParameter: string,
|};

export class ProfilePromotablePinCard extends PureComponent<Props> {
  componentDidMount() {
    logQuickPromoteEvents(
      'render',
      'promotable_pins_section',
      PCONST.thrift.EventType.RENDER,
      PCONST.thrift.ComponentType.USER_PROMOTABLE_PINS,
    );
  }

  promoteButtonClick = () => {
    const { dispatch, grid_index, onPromote, pin, view, viewParameter } = this.props;

    logQuickPromoteEvents(
      'click',
      'promotable_pins_section',
      PCONST.thrift.EventType.CLICK,
      PCONST.thrift.ComponentType.USER_PROMOTABLE_PINS,
      { view, viewParameter, grid_index },
    );

    if (onPromote) {
      onPromote();
    }
    dispatch(showQuickPromoteModal(pin));
  };

  render() {
    const { carouselPin, pin, isShort, show90DaysStats } = this.props;
    if (!pin) {
      return null;
    }

    const { aggregated_pin_data = {}, creator_analytics } = pin;

    const hasPinStatsData =
      Object.keys(creator_analytics || {}).length !== 0 ||
      (Object.keys(aggregated_pin_data || {}).length !== 0 &&
        Object.keys((aggregated_pin_data && aggregated_pin_data.creator_analytics) || {}).length !==
          0);
    const stats =
      (aggregated_pin_data && aggregated_pin_data.creator_analytics) || creator_analytics;

    return (
      <Box display="flex" direction="column" marginRight={4}>
        {typeof carouselPin !== 'undefined' ? (
          <Box shape="rounded" width={GRID_ITEM_WIDTH}>
            <DeprecatedPinRep pin={carouselPin} slotIndex={0} />
          </Box>
        ) : (
          <NavigateLink to={`/pin/${pin ? pin.id : ''}/`}>
            <DisplayPinImage pin={pin} imgHeight={isShort ? 236 : 354} />
          </NavigateLink>
        )}
        <Box display="flex" direction="row" marginTop={1} minHeight={17}>
          {/* We need the 100% width here for an IE11 flexbox bug */}
          <Box paddingX={2} flex="grow" width="100%">
            {hasPinStatsData &&
              stats && (
                <PinStatsOnGrid
                  stats={stats}
                  isVideo={false}
                  isStoryPin={false}
                  show90Days={show90DaysStats}
                />
              )}
          </Box>
        </Box>
        <Box width="100%" marginTop={4}>
          <BoostTextExperiment>
            {({ anyEnabled }) =>
              anyEnabled ? (
                <Button
                  color="red"
                  onClick={this.promoteButtonClick}
                  text={i18n._(
                    'Boost',
                    'Boost button for pins in the promotable section on own profile overview',
                  )}
                />
              ) : (
                <Button
                  color="red"
                  onClick={this.promoteButtonClick}
                  text={i18n._(
                    'Promote',
                    'Promote button for pins in the promotable section on own profile overview',
                  )}
                />
              )
            }
          </BoostTextExperiment>
        </Box>
      </Box>
    );
  }
}

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default connect(({ pins }, ownProps) => {
  const { pin } = ownProps;
  let id;
  if (pin !== null && pin !== undefined) {
    id = pin.id;
  }
  if (pins && pins[id]) {
    const { carousel_data } = pins[id];
    // return the full pin if it's a carousel. we need it for rendering purposes
    if (carousel_data) {
      return {
        carouselPin: pins[id],
      };
    }
  }

  return {};
})(ProfilePromotablePinCard);
